module.exports = __webpack_public_path__ + "assets/img/ico__phone.1bee621b.png";